<template>
  <el-dialog title="转工单"
    :visible.sync="$parent.dialogVisible"
    width="30%">
    <el-form :model="form"
      label-width="80px"
      ref="ruleForm"
      :rules="rules">
      <el-form-item style="margin-bottom: 10px"
        label="工单名称"
        prop="name">
        <p>{{ activeItem.deviceName }}</p>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="工单类型">
        <p>维修</p>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="设备地址">
        <p>{{ activeItem.location }}</p>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="选择设备">
        <p>{{ activeItem.deviceName }}</p>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="工单级别">
        <p :style="{
            color:
              activeItem.alarmSeverity == '高危'
                ? '#EC5453'
                : activeItem.alarmSeverity == '危险'
                ? '#FF9400'
                : '#777777',
          }">
          {{ activeItem.alarmSeverity }}
        </p>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="处理人"
        prop="user">
        <el-select v-model="form.user"
          multiple
          placeholder="请选择处理人"
          style="width: 100%">
          <el-option v-for="item in optionsList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px"
        label="工单描述">
        <p>{{describe}}</p>
      </el-form-item>
    </el-form>

    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button type="primary"
        @click="submitForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem"],
  data() {
    return {
      form: { user: [] },
      rules: {
        user: [{ required: true, message: "请选择处理人", trigger: "change" }],
      },
      optionsList: [],
      describe: "",
    };
  },
  methods: {
    async getUserList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:worksheets:edit",
      });
      if (res && res.data.code == 200) {
        this.optionsList = res.data.data;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          return new Promise(async (resolve) => {
            let res = await api.logisticsCreateWorkOrder({
              description: this.activeItem.deviceName,
              location: this.activeItem.location,
              deviceId: this.activeItem.deviceId,
              type: "DEVICE_ALARM",
              status: "TOBE_REPAIR",
              action: "ASSIGN",
              level:
                this.activeItem.level == "CRITICAL"
                  ? "HIGH"
                  : this.activeItem.level == "MAJOR"
                  ? "MEDIUM"
                  : "LOW",
              assignStaffIds: this.form.user,
              remark: this.describe,
              alarmId: this.activeItem.alarmId,
            });
            if (res && res.data.code == 200) {
              this.btnLoading = false;
              this.$message.success("添加成功!");
              this.$parent.dialogVisible = false;
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.$parent.getAlarmsList();
              }, 1000);
            } else {
              this.$message.error(res.data.codeMsg);
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.describe = `报警类型:${this.activeItem.type}; 当前状态:${this.activeItem.status}`;
    this.getUserList();
  },
};
</script>

<style>
</style>